import ListProducts from "../../../components/@products/products/ListProducts";

import { routeTypes } from "../../../hooks/useSystemRoutes";

export default function ProductsPage() {

    return (
        <ListProducts 
            routeType={routeTypes.retail}
        />
    )
}       